;
define("views/modules/calendar/animated-session/exercise/cardio/history/cardio-history-list-item", function(){});

